import React, { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-datepicker/dist/react-datepicker.css";
import {
  SignUpForm,
  LogInForm,
  ForgotPasswordForm,
  ResetPasswordForm,
  ForgetPasswordFormLink,
} from "./authentication";
import {
  Home,
  AgentsList,
  AddAgent,
  EditAgent,
  AgencyProfile,
  Agencybranding,
  ListingList,
  AddListing,
  EditListing,
  Marketing,
} from "./Pages";
import { Erro404 } from "./components";
import "react-tooltip/dist/react-tooltip.css";
import PreviewAgency from "./Pages/preview/PreviewAgency";
import PreviewAgent from "./Pages/preview/PreviewAgent";
import AgentContactCard from "./Pages/preview/common/AgentContactCard";
import Enquiries from "./Pages/Enquiries/Enquiries";
import Appraisal from "./Pages/Appraisal/Appraisal";

function App() {
  const navigate = useNavigate();

  const getPath = useLocation().pathname.split("/")?.[2];
  const getUrl = useLocation().pathname.split("/")?.[1];

  const checkAuth = localStorage.getItem("AgencyToken");
  useEffect(() => {
    if (checkAuth === undefined || checkAuth === null) {
      if (getPath === "reset-password") {
      } else if (getPath === "forgot-password") {
      } else if (getUrl === "sign-up") {
      } else {
        navigate("/log-in");
      }
    }
  }, [checkAuth, navigate]);
  return (
    <>
      <Routes>
        <Route exact path="/" element={<Home />} />

        <Route exact path="/listings" element={<ListingList />} />
        <Route exact path="/listings/add/:type" element={<AddListing />} />
        <Route exact path="/listings/edit/:id" element={<EditListing />} />

        <Route exact path="/marketing" element={<Marketing />} />
        <Route exact path="/agents" element={<AgentsList />} />
        <Route exact path="/agents/add" element={<AddAgent />} />
        <Route exact path="/agents/edit/:id" element={<EditAgent />} />

        <Route exact path="/agency" element={<AgencyProfile />} />
        <Route exact path="/agencylogo" element={<Agencybranding />} />

        <Route exact path="/enquiries" element={<Enquiries />} />
        <Route exact path="/appraisal" element={<Appraisal />} />


        <Route exact path="/preview-agency" element={<PreviewAgency />} />

        {/* -------- Authentication -------- */}

        <Route exact path="/sign-up" element={<SignUpForm />} />
        <Route exact path="/log-in" element={<LogInForm />} />
        <Route
          exact
          path="/auth/forgot-password"
          element={<ForgotPasswordForm />}
        />
        <Route
          exact
          path="/auth/reset-password/:id"
          element={<ResetPasswordForm />}
        />
        <Route
          exact
          path="/auth/reset-password/:id/:token"
          element={<ForgetPasswordFormLink />}
        />

        {/* -------- 404 Not Found -------- */}

        <Route exact path="*" element={<Erro404 />} />
      </Routes>
    </>
  );
}

export default App;
